// EndToEndSolutions.js — grid of interior solution icons like reference image
import React from 'react';
import { Link } from 'react-router-dom';

const SOLUTIONS = [
  {
    label: 'Modular Kitchen',
    path: '/services/modular-kitchen',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="8" y="28" width="48" height="28" rx="1"/>
        <rect x="14" y="34" width="10" height="10" rx="1"/>
        <rect x="40" y="34" width="10" height="10" rx="1"/>
        <line x1="8" y1="56" x2="56" y2="56"/>
        <rect x="8" y="10" width="48" height="14" rx="1"/>
        <circle cx="20" cy="6" r="3" stroke="#F5A800"/>
        <circle cx="32" cy="6" r="3" stroke="#F5A800"/>
        <circle cx="44" cy="6" r="3" stroke="#F5A800"/>
        <line x1="20" y1="9" x2="20" y2="10"/>
        <line x1="32" y1="9" x2="32" y2="10"/>
        <line x1="44" y1="9" x2="44" y2="10"/>
      </svg>
    ),
  },
  {
    label: 'Storage & Wardrobe',
    path: '/services/complete-modular-site-work',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="10" y="8" width="44" height="52" rx="1"/>
        <line x1="32" y1="8" x2="32" y2="60"/>
        <line x1="10" y1="34" x2="56" y2="34"/>
        <circle cx="27" cy="21" r="2" stroke="#F5A800" fill="#F5A800"/>
        <circle cx="37" cy="21" r="2" stroke="#F5A800" fill="#F5A800"/>
        <circle cx="27" cy="47" r="2" stroke="#F5A800" fill="#F5A800"/>
        <circle cx="37" cy="47" r="2" stroke="#F5A800" fill="#F5A800"/>
      </svg>
    ),
  },
  {
    label: 'TV Units',
    path: '/services/interior-design',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="6" y="8" width="52" height="34" rx="2"/>
        <line x1="24" y1="42" x2="20" y2="56"/>
        <line x1="40" y1="42" x2="44" y2="56"/>
        <line x1="16" y1="56" x2="48" y2="56"/>
        <rect x="12" y="14" width="40" height="22" rx="1" stroke="#F5A800"/>
      </svg>
    ),
  },
  {
    label: 'False Ceiling',
    path: '/services/false-ceiling-painting',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="14" x2="56" y2="14"/>
        <line x1="8" y1="22" x2="56" y2="22"/>
        <line x1="32" y1="22" x2="32" y2="34"/>
        <ellipse cx="32" cy="38" rx="12" ry="6" stroke="#F5A800"/>
        <line x1="26" y1="44" x2="24" y2="52"/>
        <line x1="38" y1="44" x2="40" y2="52"/>
        <line x1="32" y1="44" x2="32" y2="52"/>
        <circle cx="32" cy="52" r="2" fill="#F5A800" stroke="#F5A800"/>
      </svg>
    ),
  },
  {
    label: 'Home Lighting',
    path: '/services/home-lighting',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <line x1="32" y1="6" x2="32" y2="16"/>
        <line x1="52" y1="10" x2="46" y2="18"/>
        <line x1="58" y1="28" x2="48" y2="28"/>
        <line x1="12" y1="10" x2="18" y2="18"/>
        <line x1="6" y1="28" x2="16" y2="28"/>
        <path d="M22 30a10 10 0 1120 0c0 5-2 8-4 10v4h-12v-4c-2-2-4-5-4-10z"/>
        <line x1="26" y1="44" x2="38" y2="44"/>
        <line x1="28" y1="48" x2="36" y2="48"/>
        <line x1="30" y1="52" x2="34" y2="52"/>
        <line x1="32" y1="16" x2="32" y2="20" stroke="#F5A800"/>
      </svg>
    ),
  },
  {
    label: 'Aluminium & Glass',
    path: '/services/aluminium-glass-works',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="8" y="8" width="22" height="48" rx="1"/>
        <rect x="34" y="8" width="22" height="48" rx="1"/>
        <line x1="8" y1="32" x2="30" y2="32"/>
        <line x1="34" y1="32" x2="56" y2="32"/>
        <line x1="19" y1="8" x2="19" y2="56"/>
        <line x1="45" y1="8" x2="45" y2="56"/>
        <circle cx="22" cy="32" r="2" fill="#F5A800" stroke="#F5A800"/>
        <circle cx="42" cy="32" r="2" fill="#F5A800" stroke="#F5A800"/>
      </svg>
    ),
  },
  {
    label: 'Wall Paint',
    path: '/services/false-ceiling-painting',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="10" y="8" width="30" height="44" rx="1"/>
        <line x1="40" y1="18" x2="54" y2="12"/>
        <path d="M40 30 L54 24 L56 32 L42 38 Z"/>
        <line x1="54" y1="38" x2="54" y2="52"/>
        <rect x="50" y="50" width="8" height="6" rx="1" stroke="#F5A800" fill="#F5A800" fillOpacity=".2"/>
        <line x1="16" y1="16" x2="34" y2="16" stroke="#F5A800"/>
        <line x1="16" y1="22" x2="34" y2="22"/>
        <line x1="16" y1="28" x2="34" y2="28"/>
      </svg>
    ),
  },
  {
    label: 'Study Tables',
    path: '/services/interior-design',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="36" x2="56" y2="36"/>
        <line x1="14" y1="36" x2="14" y2="56"/>
        <line x1="50" y1="36" x2="50" y2="56"/>
        <rect x="28" y="16" width="20" height="20" rx="1"/>
        <line x1="36" y1="16" x2="36" y2="36"/>
        <rect x="10" y="20" width="14" height="16" rx="1" stroke="#F5A800"/>
        <line x1="13" y1="24" x2="21" y2="24" stroke="#F5A800"/>
        <line x1="13" y1="28" x2="21" y2="28" stroke="#F5A800"/>
        <line x1="13" y1="32" x2="21" y2="32" stroke="#F5A800"/>
      </svg>
    ),
  },
  {
    label: 'Space Saving',
    path: '/services/interior-design',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="8" y="8" width="48" height="48" rx="1"/>
        <line x1="8" y1="28" x2="56" y2="28"/>
        <line x1="28" y1="28" x2="28" y2="56"/>
        <rect x="32" y="32" width="20" height="20" rx="1" stroke="#F5A800"/>
        <line x1="12" y1="14" x2="24" y2="14"/>
        <line x1="12" y1="20" x2="24" y2="20"/>
        <line x1="38" y1="14" x2="50" y2="14"/>
        <line x1="38" y1="20" x2="50" y2="20"/>
      </svg>
    ),
  },
  {
    label: 'Bathroom',
    path: '/services/complete-modular-site-work',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 28 H52 V46 Q52 54 44 54 H20 Q12 54 12 46 V28 Z"/>
        <line x1="12" y1="28" x2="12" y2="16"/>
        <path d="M12 16 Q12 10 18 10 Q24 10 24 16" stroke="#F5A800"/>
        <line x1="8" y1="54" x2="12" y2="60"/>
        <line x1="52" y1="54" x2="56" y2="60"/>
        <line x1="8" y1="28" x2="56" y2="28"/>
        <ellipse cx="38" cy="16" rx="6" ry="4"/>
        <line x1="38" y1="12" x2="38" y2="8"/>
        <line x1="44" y1="14" x2="48" y2="12"/>
      </svg>
    ),
  },
  {
    label: 'Pooja Unit',
    path: '/services/interior-design',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="16" y="12" width="32" height="44" rx="1"/>
        <path d="M16 12 Q32 4 48 12"/>
        <line x1="16" y1="32" x2="48" y2="32"/>
        <rect x="22" y="36" width="8" height="12" rx="1" stroke="#F5A800" fill="#F5A800" fillOpacity=".15"/>
        <rect x="34" y="36" width="8" height="12" rx="1"/>
        <circle cx="32" cy="22" r="4"/>
        <line x1="32" y1="8" x2="32" y2="12"/>
        <line x1="26" y1="10" x2="28" y2="12"/>
        <line x1="38" y1="10" x2="36" y2="12"/>
      </svg>
    ),
  },
  {
    label: 'Kids Bedroom',
    path: '/services/interior-design',
    icon: (
      <svg width="52" height="52" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="8" y="10" width="20" height="44" rx="1"/>
        <rect x="8" y="28" width="20" height="26" rx="1"/>
        <line x1="8" y1="28" x2="28" y2="28"/>
        <rect x="32" y="10" width="24" height="44" rx="1"/>
        <line x1="32" y1="30" x2="56" y2="30"/>
        <line x1="44" y1="10" x2="44" y2="54"/>
        <rect x="34" y="32" width="8" height="20" rx="0" stroke="#F5A800"/>
        <rect x="46" y="32" width="8" height="20" rx="0"/>
        <line x1="36" y1="14" x2="42" y2="14"/>
        <line x1="36" y1="18" x2="42" y2="18"/>
        <line x1="36" y1="22" x2="42" y2="22"/>
      </svg>
    ),
  },
];

export default function EndToEndSolutions() {
  return (
    <section className="section-pad" style={{ background: '#0c0c0c', borderTop: '1px solid rgba(245,168,0,0.08)' }}>
      <div className="container">
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <p className="tag-label" style={{ justifyContent: 'center', marginBottom: '0.75rem' }}>One-Stop Shop</p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.8rem,4vw,2.8rem)', fontWeight: 400, color: '#fff', marginBottom: '0.5rem' }}>
            End-to-End <em style={{ color: '#F5A800' }}>Interior Solutions</em>
          </h2>
          <div className="gold-line center" />
          <p style={{ color: '#888', fontSize: '0.88rem', maxWidth: '520px', margin: '0 auto' }}>
            Everything your home needs — designed, crafted and installed by Wedoo Interiors.
          </p>
        </div>

        {/* Icon grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(6, 1fr)',
          gap: '0',
        }}>
          {SOLUTIONS.map((s, i) => (
            <Link key={s.label} to={s.path} style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              padding: '2rem 1rem', textDecoration: 'none',
              borderRight: (i + 1) % 6 !== 0 ? '1px solid rgba(255,255,255,0.05)' : 'none',
              borderBottom: i < 6 ? '1px solid rgba(255,255,255,0.05)' : 'none',
              transition: 'all 0.3s ease',
              gap: '0.85rem',
              color: '#888',
            }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(245,168,0,0.05)'; e.currentTarget.style.color = '#F5A800'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#888'; }}>
              <div style={{ color: 'inherit', transition: 'color 0.3s' }}>
                {s.icon}
              </div>
              <span style={{ fontSize: '0.75rem', fontWeight: '500', letterSpacing: '0.04em', textAlign: 'center', lineHeight: '1.4', color: 'inherit' }}>
                {s.label}
              </span>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <Link to="/services" className="btn btn-outline" style={{ fontSize: '0.72rem' }}>
            Explore All Services →
          </Link>
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          section .container > div[style*="repeat(6"] {
            grid-template-columns: repeat(4,1fr) !important;
          }
        }
        @media (max-width: 640px) {
          section .container > div[style*="repeat(6"] {
            grid-template-columns: repeat(3,1fr) !important;
          }
        }
        @media (max-width: 400px) {
          section .container > div[style*="repeat(6"] {
            grid-template-columns: repeat(2,1fr) !important;
          }
        }
      `}</style>
    </section>
  );
}
